import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { Fce } from '../../fce';

@Component({
  selector: 's-input-day-interval',
  templateUrl: './s-input-day-interval.component.html',
  styleUrls: ['./s-input-day-interval.component.scss'],
  imports: [FormsModule, TranslateModule, NgbModule]
})
export class SInputDayIntervalComponent implements OnInit {

  @Input() model = null
  @Input() disabled = false
  @Input() required = false
  @Input() default: number
  @Output() modelChange = new EventEmitter()
  @Output() change = new EventEmitter()

  tmpModel: any
  intervalTypes = ["D", "W", "M", "Y"];
  selectedType = "D";

  constructor() { }

  ngOnInit(): void {
    if (Fce.empty(this.model) && !Fce.empty(this.default)) {
      this.model = `D${this.default}`
      requestAnimationFrame(() => this.modelChange.emit(this.model))
    }
    this.parseIn()
  }

  onChange() {
    this.parseOut()
    this.change.emit(this.model)
  }

  parseIn(): void {
    if (!Fce.empty(this.model)) {
      const type = this.model.charAt(0);
      if (this.intervalTypes.includes(type)) {
        this.selectedType = type;
        this.tmpModel = parseInt(this.model.substring(1));
      }
    }
  }

  parseOut(): void {
    const value = parseInt(this.tmpModel)
    if (isNaN(value))
      this.model = null
    else
      this.model = `${this.selectedType}${value}`
    this.modelChange.emit(this.model)
  }

  typeChanged(value): void {
    this.selectedType = value
    this.parseOut()
  }
}
